module.exports = __webpack_public_path__ + "static/media/TitlingGothicFBNormal-Standard.79c9eb41.woff";